export default __webpack_public_path__ + "static/media/icon-copy.ebb7f013.svg";